<template>
  <div class="d-flex flex-column justify-center align-center full-height">
    <div class="d-flex flex-column align-center message404">
      <h1>OH NO! 404</h1>
      <p><b>THE LINK YOU FOLLOWED IS PROBABLY</b></p>
      <p><b>BROKEN OR THE PAGE HAS BEEN REMOVED.</b></p>
      </br>
      <v-btn
        large
        outlined
        color="#34417c"
        @click="goHome"
        
      >
      Go to home
      </v-btn>
    </div>
    <div>
      <v-img
        contain
        height="auto"
        max-width="450"
        :src="require('@/assets/img/connectionFail.png')"
      ></v-img>
    </div>
  </div>
</template>

<style>
</style>

<script>
export default {
  name: '404',
  methods: {
    goHome: function () {
      this.$router.push({ name: 'classroomList' }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue